<template>
  <div>
    <b-form-group>
      <h5>{{ $t('Customers/Max customers') + ' ' + this.dataDiagram.cur_users + '/' + this.dataDiagram.max_users}}</h5>
      <b-progress variant="success" animated class="mb-3"
      v-b-popover.hover.top="this.dataDiagram.cur_users + '/' + this.dataDiagram.max_users"
      :value="this.dataDiagram.cur_users"
      :max="this.dataDiagram.max_users"/>
      <h5>{{ $t('Accounts/Max accounts')  + ' ' + this.dataDiagram.cur_accounts + '/' + this.dataDiagram.max_accounts}}</h5>
      <b-progress variant="success" animated
      v-b-popover.hover.top="this.dataDiagram.cur_accounts + '/' + this.dataDiagram.max_accounts"
      :value="this.dataDiagram.cur_accounts"
      :max="this.dataDiagram.max_accounts"/>
    </b-form-group>
    <b-form-group :label="$t('End date license')" label-cols="4" label-cols-xl="4" label-cols-md="4">
      <b-form-input type="datetime-local" v-model="this.dataDiagram.time" disabled/>
    </b-form-group>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      nowTime: moment().format('YYYY-MM-DDThh:mm')
    }
  },
  methods: {
    endLicense () {
      this.nowTime = Number(Date.parse(this.nowTime)) / 1000
      let endLicense = this.dataDiagram.till - 2592000
      if (this.nowTime >= endLicense) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('License expires'), 'Error')
      }
    }
  },
  computed: {
    dataDiagram () {
      let dataDiagram = this.$store.getters['Settings/LICENSE']
      dataDiagram.time = moment(Number(dataDiagram.till) * 1000).format('YYYY-MM-DDThh:mm')
      return dataDiagram
    }
  },
  mounted () {
    this.endLicense()
    this.$store.dispatch('Settings/GET_LICENSE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/Dashboard.vue